import { render, staticRenderFns } from "./PortraitImageDemo.vue?vue&type=template&id=3916573a"
import script from "./PortraitImageDemo.vue?vue&type=script&lang=js"
export * from "./PortraitImageDemo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports